import { Button, Heading, Table, TableContainer, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { Fragment, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { obtenerReservasSocio } from "../../../../services/obtenerReservasSocio";
import { Loading } from "../../../Common/Loading";
import { useTranslation } from "react-i18next";


const ReservasSocio = () => {
    const { idSocio } = useParams()
    const { t } = useTranslation()

    const [loading, setLoading] = useState(true);
    const [correo, setCorreo] = useState('');
    const [nombre, setNombre] = useState('');
    const [apellidos, setApellidos] = useState('');
    const [reservas, setReservas] = useState([]);

    const navigate = useNavigate()

    const requestReservas = async () => {
        try {
            const reserva = await obtenerReservasSocio(idSocio);
            setCorreo(reserva.data.correo);
            setNombre(reserva.data.nombre);
            setApellidos(reserva.data.apellidos);
            setReservas(reserva.data.reservacion);
            setLoading(false);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        if(idSocio) {
            requestReservas();
        }
    }, [idSocio])

    return (
        <div className="pxcontainer" style={{ padding: '20px' }}>
            {
                loading ? 
                    <Loading/>
                    :
                    <Fragment>
                        <Heading as ="h2" size="lg" mb={4}>
                            {t('SOCIO_RESERVATIONS')}: {nombre} {apellidos} ({correo})
                        </Heading>
                        <TableContainer>
                            <Table variant='simple'>
                                <Thead>
                                    <Tr>
                                    <Th>{t('RESERVATION_TYPE')}</Th>
                                    <Th>{t('ARRIVAL_DATE')}</Th>
                                    <Th>{t('DEPARTURE_DATE')}</Th>
                                    <Th>{t('GUEST_NAME')}</Th>
                                    <Th>{t('CABIN_TYPE')}</Th>
                                    <Th>{t('TOKEN')}</Th>
                                    <Th>{t('TRANSACTION_NUMBER')}</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {reservas.map((reserva) => (
                                        <Tr key={reserva.id}>
                                            <Td>{reserva.tipoReservacion}</Td>
                                            <Td>{reserva.fechaLlegada.split('T')[0]}</Td>
                                            <Td>{reserva.fechaSalida.split('T')[0]}</Td>
                                            <Td>{reserva.nombreQuienReserva}</Td>
                                            <Td>{reserva.tipoCabana}</Td>
                                            <Td>{reserva.token}</Td>
                                            <Td>{reserva.numeroTransaccion}</Td>
                                        </Tr>
                                    ))}
                                </Tbody>
                            </Table>
                        </TableContainer>
                        <div className="d-flex mt-4" style={{ justifyContent: 'right' }}>
                            <Button
                                colorScheme='blue'
                                mt={4}
                                onClick={() => navigate('/socios')}
                            >
                                {t('GO_BACK')}
                            </Button>
                        </div>
                    </Fragment>
            }
        </div>
    );

}


export default ReservasSocio;